export default __webpack_public_path__ + "static/media/kanji2.f26aae06.png";